// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page__checkout-learning-unit-option .content__make-payment{height:-webkit-max-content;height:-moz-max-content;height:max-content;box-shadow:0 4px 8.8px 0 rgba(166,166,185,.5490196078431373);border-radius:1em;padding:24px}.page__checkout-learning-unit-option .text__total-price{font-size:24px;font-weight:700}.page__checkout-learning-unit-option .text__total-price strong *{margin:0!important}", ""]);
// Exports
module.exports = exports;
